/* RESPONSIBLE TEAM: team-frontend-tech */
export default function formatList(list, options = {}) {
  let formatter = new Intl.ListFormat(this.primaryLocale, options);
  return formatter.format(list);
}
